<template>
  <q-card
    :dark="isDarkModeGlobal"
    flat
  >
    <header-component/>
    <q-card-section>
      <TusCalculator v-if="confirmConditionsOfUse" />
    </q-card-section>
    <q-dialog
      v-model="showWorkerDialog"
      persistent
    >
      <q-card
        :dark="isDarkModeGlobal"
        style="min-width: 300px"
      >
        <q-card-section>
          <div class="column items-center q-pa-md">
            <q-spinner-puff
              color="primary"
              size="xl"
            />
            <div class="text-h6">
              Calculating
              {{ calculatorStore.loading_processes.join(", ")}}
              ...
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            label="Cancel"
            color="warning"
            flat
            @click="calculatorStore.currentCancelFn && calculatorStore.currentCancelFn()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-card>
</template>
<script setup lang="ts">
import TusCalculator from './components/TusCalculator.vue'
import HeaderComponent from './components/HeaderComponent.vue'
import { useCalculatorStore } from './stores/calculator.store'
import { storeToRefs } from "pinia"
import {onBeforeMount, ref} from "vue"
import {QSpinner} from "quasar";
const calculatorStore = useCalculatorStore()
const {
  confirmConditionsOfUse,
  isDarkModeGlobal,
  showWorkerDialog
} = storeToRefs(calculatorStore)

const updateDarkMode = (e) => {
  isDarkModeGlobal.value = e.matches
}

onBeforeMount(() => {
  // Check the initial color scheme
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', updateDarkMode)
  isDarkModeGlobal.value = ref(window.matchMedia('(prefers-color-scheme: dark)').matches)
})
</script>

